import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const USER_PATH = 'user'
const USER_WITH_ROLE_PATH = 'userWithRole'
const USER_ROLE_PATH = 'userRole'

export function createOrUpdateUserWithRole(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_WITH_ROLE_PATH}/createOrUpdate`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getDetailUserWithRole(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${USER_WITH_ROLE_PATH}/getById`, {
            params: {
                userId,
                id,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPatientOwned(userId, id, dto = false) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${USER_WITH_ROLE_PATH}/getOwnedPatient`, {
            params: {userId, id, dto},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getListUserWithRoles(userId, rows, dto, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_WITH_ROLE_PATH}/getList`,
            filterRequest,
            {
                params: {
                    userId,
                    dto,
                    rows,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPageUserWithRoles(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_WITH_ROLE_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//TODO : Change to create user role (Remove)
export function assignHCPRole(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_WITH_ROLE_PATH}/assignRoleForHCP`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//TODO : Change to get list user Management
export function getHCPManagement(userId, id, dto = false) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${USER_PATH}/getOwnedHCP`, {
            params: {userId, id, dto},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//TODO : Change to delete user role (Remove)
export function deleteUserRole(userId, userRoleId) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${USER_ROLE_PATH}/deleteById`, {
            params: {userId, userRoleId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
